import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppShell } from './layout/app-shell/app-shell';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AppShell],
  selector: 'app-root',
  template: '<app-app-shell />',
})
export class App {}
